/**
 * useTriage — cola única (GET /api/triage). Se consulta cada 60 s y tras cada acción.
 * Solo trabaja si el flag ff_triage está encendido (si no, no llama a nada).
 */
import { useCallback, useEffect, useState } from "react";
import { api } from "../api/client.js";
import { useAuth } from "../context/AuthContext.jsx";
import { useFlag } from "./useFlags.js";

export function useTriage(fuente = null) {
  const { miembro } = useAuth();
  const activo = useFlag("ff_triage");
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const recargar = useCallback(async () => {
    if (!miembro || !activo) return;
    try { setData(await api.getTriage(fuente ? { fuente } : {})); setError(null); }
    catch (e) { setError(e); }
  }, [miembro?.id, activo, fuente]);

  useEffect(() => {
    recargar();
    if (!miembro || !activo) return;
    const t = setInterval(recargar, 60_000);
    return () => clearInterval(t);
  }, [recargar]);

  return { data, error, recargar, activo };
}
